import { render, staticRenderFns } from "./DataPortal.vue?vue&type=template&id=3f2f6c91&"
import script from "./DataPortal.vue?vue&type=script&lang=js&"
export * from "./DataPortal.vue?vue&type=script&lang=js&"
import style0 from "./DataPortal.vue?vue&type=style&index=0&id=3f2f6c91&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports